<main id="main-content" aria-label="School Management" [attr.inert]="(isVisible || deleteConfirmVisible) ? '' : null">
  <div class="max-h-fit px-0 md:px-4 lg:px-20 pt-10">
    <div class="grid grid-cols-2 py-5">
      <div class="col-span-2 lg:col-span-1 items-center pb-4">
        <h1 class="text-dark-purple text-3xl font-bold">Schools</h1>
      </div>
        <div class="col-span-2 pb-4 flex flex-col md:flex-row md:justify-end">
          @if (!isDistrictAdmin) {
            <prism-btn
                btnClass="bg-white text-dark-purple font-bold border-2 p-0 m-0 rounded-xl border-dark-purple"
                (click)="addSchool()">
            <i class="uil uil-plus text-dark-purple font-bold pr-1"></i>Add School
            </prism-btn>
          }
        </div>
          <div class="col-span-2 grid grid-cols-1 lg:grid-cols-12 gap-4 pb-4 items-start">
            <div class="lg:col-span-5">
              <prism-input
                inputType="text"
                [control]="searchForm.get('search')"
                [required]="false"
                placeHolder="Search for School"
                autocomplete="off"
                [hasSearch]="true"
                (search)="searchSchools()">
              </prism-input>
            </div>

            <div class="hidden lg:block lg:col-span-3"></div>

            <div class="lg:col-span-4 lg:col-start-9 w-full">
              <prism-select-organization
                [control]="searchForm.get('organizationId')"
                [required]="false">
              </prism-select-organization>
            </div>
          </div>

    </div>
    <div>
    <prism-table [columns]="columns"
                [colHeaders]="colHeaders"
                [tableData]="data"
                [isDelete]="true"
                [isEdit]="true"
                [pageIndex]="pageIndex"
                [pageSize]="pageSize"
                [totalData]="totalData"
                (edit)="editSchool($event)"
                (pageIndexChange)="handlePageIndexChange($event)"
                (pageSizeChange)="handlePageSizeChange($event)"
                (delete)="deleteSchool($event)"
                [hideActionBtns]="isDistrictAdmin"
                (columnDirectionChange)="handleColumnDirectionChange($event)">
    </prism-table>
  </div>
  </div>
</main>
<div
  *ngIf="isVisible"
  class="fixed inset-0 z-50 flex items-start justify-center bg-black/50 px-4 py-8 overflow-y-auto"
  role="presentation"
  (click)="handleCancel()">

  <section
    #schoolDialog
    class="relative w-full max-w-lg rounded bg-white p-6 shadow-lg my-auto"
    role="dialog"
    aria-modal="true"
    aria-labelledby="school-dialog-title"
    tabindex="-1"
    (click)="$event.stopPropagation()"
    (keydown)="onDialogKeydown($event, schoolDialog)">

    <button
      #schoolCloseButton
      type="button"
      class="absolute right-4 top-4 bg-transparent border-0 cursor-pointer text-2xl leading-none"
      [attr.aria-label]="'Close ' + modalTitle + ' dialog'"
      (click)="handleCancel()">
      &times;
    </button>

    <h2 id="school-dialog-title" class="text-xl font-semibold mb-4 pr-8">
      {{ modalTitle }}
    </h2>

    <form class="grid gap-4" [formGroup]="schoolForm">
      <prism-input
        [control]="schoolForm.get('name')"
        placeHolder="Enter school name"
        label="School Name"
        [required]="true"
        inputType="text"
        autocomplete="off"
        [maxLength]="150">
      </prism-input>

      <div class="col-span-1">
        <prism-select-organization
          [control]="schoolForm.get('districtId')"
          label="District"
          placeHolder="Select a District"
          [required]="true"
          [readOnly]="isDistrictAdmin">
        </prism-select-organization>
      </div>
    </form>

    <div class="flex justify-end gap-2 mt-4 pt-4 border-t">
      <prism-btn
        btnClass="bg-white text-dark-purple font-bold border-2 rounded-xl border-dark-purple"
        (click)="handleCancel()">
        Cancel
      </prism-btn>
      <prism-btn [disabled]="schoolForm.pristine" (click)="handleOk()">
        Save
      </prism-btn>
    </div>
  </section>
</div>

<div
  *ngIf="deleteConfirmVisible"
  class="fixed inset-0 z-50 flex items-start justify-center bg-black/50 px-4 py-8 overflow-y-auto"
  role="presentation">

  <section
    #deleteConfirmDialog
    class="relative w-full max-w-md rounded bg-white p-6 shadow-lg my-auto"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="delete-confirm-title"
    aria-describedby="delete-confirm-message"
    tabindex="-1"
    (keydown)="onDeleteConfirmKeydown($event, deleteConfirmDialog)">

    <h2 id="delete-confirm-title" class="text-xl font-semibold mb-4">
      {{ deleteConfirmTitle }}
    </h2>

    <p id="delete-confirm-message" class="mb-4">
      {{ deleteConfirmContent }}
    </p>

    <div class="flex justify-end gap-2">
      <prism-btn
        btnClass="bg-white text-dark-purple font-bold border-2 rounded-xl border-dark-purple"
        (click)="cancelDelete()">
        No
      </prism-btn>
      <prism-btn (click)="confirmDelete()">
        Yes
      </prism-btn>
    </div>
  </section>
</div>
